import React, { Fragment } from "react";
import { connect } from "react-redux";
import { ApplicationState, ConnectedReduxProps } from "@reducers/index";
import { VideoContent } from "@models/video-contents";
import {
  deleteRequest,
  fetchRequest,
  createRequest,
  updateRequest
} from "@actions/video-content";
import VideoContentForm from "@components/video-contents/Form";
import videoContentApi from "@api/video-content";
import { injectIntl } from "react-intl";

interface PropsFromState {
  loading: boolean;
  data: VideoContent[];
  errors?: string;
  count: number;
}

interface PropsFromDispatch {
  fetchRequest: typeof fetchRequest;
  deleteRequest: typeof deleteRequest;
}

// Combine both state + dispatch props - as well as any props we want to pass - in a union type.
type AllProps = PropsFromState & PropsFromDispatch & ConnectedReduxProps;

class VideoContentFormPage extends React.Component<AllProps> {

  constructor(props) {
    super(props);

    const video_id = this.props.match.params.id;
    let params = new URLSearchParams(this.props.history.location.search);
    const id = video_id || params.get('ref');

    this.state = {
      videoContent: null,
      videoContent_id: id,
      is_fetched: false,
      createByRef: params.get('ref') ? true : false
    }
  }

  componentDidMount() {
    if (this.state.videoContent_id) {
      this.fetchItem();
    }
  }

  fetchItem = () => {
    videoContentApi
      .getItem({
        params: {
          id: this.state.videoContent_id
        }
      })
      .then(({ data }) => {
        const { ["id"]: omit, ...rest } = data;
        rest.video_content_person_roles = stripId(rest.video_content_person_roles);
        this.setState({
          videoContent:  this.state.createByRef ? rest : data
        });
      })
      .catch(error => console.log(error));
  };

  getContent = () => {
    if (this.state.videoContent_id && !this.state.videoContent) {
      return null;
    }

    return (
      <VideoContentForm
        videoContent={this.state.videoContent}
        intl={this.props.intl}
        listUrl={"/video-contents"}
        history={this.props.history}
        updateRequest={this.props.updateRequest}
        createRequest={this.props.createRequest}
      />
    );
  };

  render() {
    return <Fragment>{this.getContent()}</Fragment>;
  }
}

const mapStateToProps = ({ videoContents }: ApplicationState) => ({
  loading: videoContents.loading,
  errors: videoContents.errors
});

const mapDispatchToProps = {
  createRequest,
  updateRequest
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(VideoContentFormPage));

const stripId = <T extends { id: string}>(objectArray: T[]) => {
  return objectArray.map(({ id, ...rest }) => rest)
}